import { Templates } from './templates';
import { IRenderer } from '../renderer';

export class StringRenderer implements IRenderer {
  RenderHeader(preview: any) {
    return '';
  }
  RenderBody(preview: any) {
    return preview;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/preview.service/renderers/string.renderer.ts